<template>
  <v-btn :href="link.url" target="_blank" class="mr-2" rounded color="primary" dark text small>
    {{ link.descr }}
    <v-icon v-if="link.private" small right>mdi-lock</v-icon></v-btn
  >
</template>
<script>
export default {
  props: {
    link: {
      type: Object,
      default() {
        return { url: '', private: false, descr: '' };
      },
    },
  },
};
</script>
